<template>
  <keep-alive :include="include">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
    import {getActivityRouterMenus} from "../../permission/module";

    export default {
        name: "Activity",
        provide() {
            return {
                parent: this
            }
        },
        data() {
            return {
                routers: null,
                modules: null
            }
        },
        computed: {
            include() {
                return this.$store.getters.include;
            },
            activity() {
                return this.$store.getters.activity;
            },
            // 是否是统筹小组成员
            editable() {
                let res = false;
                const activity = this.activity;
                if(activity && (activity.charge_status == 0 || activity.charge_status == 1)) {
                    res = true;
                }
                return res;
            }
        },
        watch: {
            id() {
                this.getActivity();
            },
            '$route.name'(val) {
                if(this.routers && this.routers.indexOf(val) === -1) {
                    this.$router.replace({name: 'Forbidden'});
                }
            }
        },
        created() {
            this.getActivity();
        },
        beforeDestroy() {
            this.$store.commit("setSubMenus", null);
            this.$store.commit("setActivity", null);
        },
        methods: {
            getActivity() {
                let url = `/activity/activity/get-index?activity_id=${this.$route.params.id}`;
                this.$axios(url).then(this.dealInfo);
            },
            setRouterMenus(activity) {
                const {routers, menus, modules} = getActivityRouterMenus(activity);
                this.$store.commit("setSubMenus", menus);
                this.routers = routers;
                this.modules = modules;
            },
            dealInfo(activity) {
                this.$store.commit("setActivity", activity);
                this.setRouterMenus(activity);
            }
        }
    }
</script>

<style scoped>

</style>
